<template>
  <h2>
    <slot />
  </h2>
</template>